import moment from '@g4/moment-utc';
import { tripTypeValues } from '../../utils/constants/trackingConstants';

const ancillaryTypesName = {
  PRIORITY_BOARDING: 'Priority Boarding',
  CHECK_IN_BAG: 'Checked Bags',
  CARRY_ON_BAG: 'Carry On Bag',
  TRIP_FLEX: 'Trip Flex',
  PETC: 'Pet in Cabin',
  ONBOARD_ENTERTAINMENT: 'Onboard Entertainment',
  CARRY_ON_BAG_AIRPORT: 'Carry On Bag',
  CHECK_IN_BAG_AIRPORT: 'Checked Bags',
  CARRY_ON_BAG_PREDEPARTURE: 'Carry On Bag',
  CHECK_IN_BAG_PREDEPARTURE: 'Checked Bags',
};

const ancillaryAffinity = {
  PRIORITY_BOARDING: 'Priority Boarding',
  CHECK_IN_BAG: 'Bags/Checked Bags',
  CARRY_ON_BAG: 'Bags/Carry On Bag',
  TRIP_FLEX: 'Trip Flex',
  PETC: 'Pet in Cabin',
  ONBOARD_ENTERTAINMENT: 'Onboard Entertainment',
  CARRY_ON_BAG_AIRPORT: 'Bags/Carry On Bag',
  CHECK_IN_BAG_AIRPORT: 'Bags/Checked Bags',
  CARRY_ON_BAG_PREDEPARTURE: 'Bags/Carry On Bag',
  CHECK_IN_BAG_PREDEPARTURE: 'Bags/Checked Bags',
};

const ancillaryVariantName = {
  PRIORITY_BOARDING: 'PB',
  CHECK_IN_BAG: 'Checked Bags',
  CARRY_ON_BAG: 'Carry On Bag',
  TRIP_FLEX: 'Trip Flex',
  PETC: 'PETC',
  ONBOARD_ENTERTAINMENT: 'Onboard Entertainment',
  CARRY_ON_BAG_AIRPORT: 'Carry On Bag',
  CHECK_IN_BAG_AIRPORT: 'Checked Bags',
  CARRY_ON_BAG_PREDEPARTURE: 'Carry On Bag',
  CHECK_IN_BAG_PREDEPARTURE: 'Checked Bags',
};

const getAncillaryRawProduct = (
  ancillaryType,
  flightInfo,
  operatedBy,
  index,
  quantity,
  itemPrice,
  searchCriteria,
  affinityString,
  totalQuantity
) => {
  const {
    tripType,
    origin,
    departDate,
    returnDate,
    adultsCount,
    lapInfantCount,
    childrenCount,
    infantCount,
  } = searchCriteria;

  const flightDate = flightInfo?.flight.id.split('-G4-')[0];
  const flightNumber = flightInfo?.flight.id.split('-G4-')[1];
  const flightDirection = origin === flightInfo?.flight.origin.code ? 'D' : 'R';
  const route =
    flightInfo?.flight.origin.code + flightInfo?.flight.destination.code;
  const ancillaryName = ancillaryTypesName[ancillaryType];
  const productAffinity = ancillaryAffinity[ancillaryType];
  const ancillaryVariant = ancillaryVariantName[ancillaryType];
  const itemId = `${ancillaryName}-${route}-${flightNumber}-${flightDate}`;
  const totalPaxCount =
    adultsCount + childrenCount + lapInfantCount + infantCount;
  const bookingDaysOut = moment(departDate?.date).diff(moment(), 'days');
  const price =
    quantity > 0 &&
    (ancillaryName === ancillaryTypesName.PETC ||
      ancillaryName === ancillaryTypesName.PRIORITY_BOARDING)
      ? itemPrice * quantity
      : itemPrice;

  return {
    item_id: itemId,
    item_name: ancillaryName,
    coupon: '',
    discount: '',
    affiliation: 'WWW - Booking',
    index: index ? index : '',
    item_brand: (operatedBy && operatedBy?.carrier) || 'G4',
    item_category: 'Air Ancillary',
    item_category2: productAffinity,
    item_category3: flightDirection,
    item_category4: route,
    item_category5: affinityString,
    item_list_id: itemId,
    item_variant: `${ancillaryVariant}-${route}-${flightNumber}-${flightDate}`,
    price: price,
    quantity: totalQuantity ? totalQuantity : 1,
    item_promotion_name: '',
    item_promotion_id: '',
    item_partial_reservation: '',
    item_loyalty_points_discount: '',
    item_flight_booking_type: tripType,
    item_booking_start: departDate?.date,
    item_booking_end:
      tripType === tripTypeValues.ROUNDTRIP
        ? returnDate?.date
        : departDate?.date,
    item_booking_days_out: bookingDaysOut,
    item_count_child: childrenCount,
    item_count_lap_child: lapInfantCount,
    item_count_adult: adultsCount,
    item_count_infant: infantCount,
    item_count_total: totalPaxCount,
    item_credit_applied: '',
    item_flight_voucher_discount: 0,
    item_round_trip_discount: 0,
  };
};

export default getAncillaryRawProduct;
